import React, { useEffect, useMemo, useState } from 'react';
import { Card } from 'primereact/card';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Tag } from 'primereact/tag';
import { Button } from 'primereact/button';
import { useLocation } from 'react-router-dom';
import { getOrders } from '../Services/OrdersApi';

export default function OrdersPage() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const [statusFilter, setStatusFilter] = useState('all'); // normalized: 'all' | 'pending' | 'in_transit' | 'delivered' | 'completed'
  const [search, setSearch] = useState('');

  useEffect(() => {
    // Read status from URL once on mount
    const params = new URLSearchParams(location.search);
    const status = (params.get('status') || 'all').toLowerCase();
    const allowed = ['all', 'pending', 'in_transit', 'delivered', 'completed'];
    setStatusFilter(allowed.includes(status) ? status : 'all');
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const data = await getOrders();
        setOrders(data);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const filtered = useMemo(() => {
    const s = search.trim().toLowerCase();
    return orders.filter(o => {
      const matchesStatus = statusFilter === 'all' || (o.status || '').toLowerCase() === statusFilter;
      const hay = `${o.order_id} ${o.customer_details?.name} ${o.customer_details?.city} ${o.drivername} ${o.trucknumber}`.toLowerCase();
      const matchesSearch = !s || hay.includes(s);
      return matchesStatus && matchesSearch;
    });
  }, [orders, statusFilter, search]);

  const severityFor = (status) => {
    const s = (status || '').toLowerCase();
    if (s === 'pending') return 'warning';
    if (s === 'in_transit') return 'info';
    if (s === 'delivered' || s === 'completed') return 'success';
    return 'secondary';
  };

  const friendlyStatus = (status) => {
    const s = (status || '').toString().replace(/_/g, ' ');
    return s.replace(/\b\w/g, (c) => c.toUpperCase());
  };

  return (
    <div style={{ padding: 20 }}>
      {/* <h2 style={{ marginTop: 0 ,color:"white"}}>Orders List</h2> */}

      {/* Search + Filter Bar */}
      {/* <Card className="cyber-card" style={{ marginBottom: 16 }}>
        <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
          <span className="p-input-icon-left" style={{ flex: 1 }}>
            <i className="pi pi-search" />
            <InputText value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search orders or customers..." style={{ width: '100%' }} />
          </span>
          <Dropdown value={statusFilter} options={[{label:'All Status', value:'all'},{label:'Pending', value:'pending'},{label:'In Transit', value:'in_transit'},{label:'Delivered', value:'delivered'},{label:'Completed', value:'completed'}]} onChange={(e) => setStatusFilter(e.value)} style={{ width: 200 }} />
          <Button icon="pi pi-refresh" label="Refresh" onClick={async () => { setLoading(true); setOrders(await getOrders()); setLoading(false); }} />
        </div>
      </Card> */}

      {/* Orders List */}
      <Card className="cyber-card">
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
          <i className="pi pi-box" />
          <strong>Orders List ({filtered.length})</strong>
        </div>

        {loading ? (
          <div>Loading...</div>
        ) : filtered.length === 0 ? (
          <div>No orders found.</div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {filtered.map((o) => (
              <div key={o.order_id} style={{ display: 'grid', gridTemplateColumns: '1.2fr 1.6fr 1.2fr 0.9fr 0.7fr', gap: 12, alignItems: 'center', borderRadius: 12, padding: '12px 14px', background: 'rgba(255,255,255,0.03)' }}>
                {/* Left: Order ID + priority + customer name/date */}
                <div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <strong>{o.order_id}</strong>
                    {o.priority && <Tag value={o.priority} severity={o.priority === 'High' ? 'danger' : o.priority === 'Medium' ? 'warning' : 'secondary'} />}
                  </div>
                  <div style={{ opacity: 0.8 }}>{o.customer_details?.name}</div>
                  <div style={{ opacity: 0.6, fontSize: 12 }}>{o.date}</div>
                </div>

                {/* Customer location */}
                <div>
                  <div style={{ fontWeight: 600 }}>{o.customer_details?.city}</div>
                  <div style={{ opacity: 0.8 }}>{o.customer_details?.address}</div>
                  <div style={{ opacity: 0.6, fontSize: 12 }}>{o.customer_details?.distance_km} km</div>
                </div>

                {/* Truck + Driver */}
                <div>
                  <div style={{ fontWeight: 600 }}>{o.trucknumber}</div>
                  <div><a href="#" onClick={(e)=>e.preventDefault()}>{o.drivername}</a></div>
                </div>

                {/* Status + distance left */}
                <div>
                  <Tag value={friendlyStatus(o.status)} severity={severityFor(o.status)} />
                  <div style={{ opacity: 0.6, fontSize: 12 }}>{o.remaining_km} km left</div>
                </div>

                {/* Time + details btn */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8 }}>
                  <div>
                    <div style={{ fontWeight: 700 }}>{o.time_primary}</div>
                    <div style={{ opacity: 0.6, fontSize: 12 }}>{o.time_secondary}</div>
                  </div>
                  <Button icon="pi pi-external-link" label="Details" outlined onClick={()=>{ /* hook detail action later */ }} />
                </div>
              </div>
            ))}
          </div>
        )}
      </Card>
    </div>
  );
}